import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useProject } from '../config/ProjectContext';
import GraphqlService from '../service/graphqlService';
import { useSnackbar } from '../providers/SnackbarContext';
import getCurrentAuthenticatedUserId from '../utils/getCurrentAuthenticatedUserId';

const useCSVExport = (params, filters, dateIni, dateEnd, rangeDates, object, projectParam = null) => {
  const { project: contextProject } = useProject();
  const project = projectParam || contextProject;
  const [loading, setLoading] = useState(false);
  const openSnackBar = useSnackbar();
  // Define the mutation at the top level of the custom hook
  const createNotificationMutation = useMutation((variables) => GraphqlService.createNotification(variables.email, variables.notificationTitle, variables.notificationDescription));

  const exportToCSV = async () => {
    try {
      setLoading(true); // Set loading before starting async operation
      const email = await getCurrentAuthenticatedUserId();
      openSnackBar('CSV file is being generated', 'info');
      // Perform mutation
      await createNotificationMutation.mutateAsync({
        email,
        notificationTitle: 'CSV file is being generated',
        notificationDescription: 'Your CSV file is being generated. You will receive a notification with the download link shortly.',
      });
      console.log('object', object);
      if (object.includes('machinelist') || object.includes('machineassetsdetail') || object.includes('machinecount')) {
        await GraphqlService.getLifeCycleObjectCSV(
          project.code, object, JSON.stringify(params), JSON.stringify(filters), dateIni, dateEnd, 90,
        );
      } else {
        await GraphqlService.getTelemetryObjectCSV(
          project.code, object, JSON.stringify(params), filters, dateIni, dateEnd, rangeDates,
        );
      }
    } catch (error) {
      console.log('Error exporting to CSV:', error);
      throw new Error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    exportToCSV,
    loading,
  };
};

export default useCSVExport;
